import {
  ComponentTypeFactory,
  FieldTypeFactory,
} from '@sentecacommerce-theme/base'
import { CheckoutProps } from './checkout.props'

export const CheckoutType = ComponentTypeFactory.create<CheckoutProps>('Checkout', {
  phone: FieldTypeFactory.text({
    required: true,
  }),
  isDev: FieldTypeFactory.boolean({ required: false }),
  errors: {
    noStoreSelected: FieldTypeFactory.text({
      required: true,
      label: 'No Store Selected Error',
    }),
    fieldIsRequired: FieldTypeFactory.text({
      required: true,
      label: 'Required Field Error',
    }),
    emailIsInvalid: FieldTypeFactory.text({
      required: true,
      label: 'Invalid Email Error',
    }),
    invalidNumber: FieldTypeFactory.text({
      required: true,
      label: 'Invalid Number',
    }),
    emailIsRequired: FieldTypeFactory.text({
      required: true,
      label: 'Email is Required Error',
    }),
    internalServerError: FieldTypeFactory.text({
      required: true,
      label: 'Internal Server Error',
    }),
    selectPaymentMethod: FieldTypeFactory.text({
      required: true,
      label: 'Select Payment Error',
    }),
    fillStreetNumberBuildingEntranceOrApartment: FieldTypeFactory.text({
      required: true,
      label: 'Fill Street Number, Building, Entrance or Apartment Error',
    }),
    streetIsRequired: FieldTypeFactory.text({
      required: true,
      label: 'Street Is Required Error',
    }),
    quarterIsRequired: FieldTypeFactory.text({
      required: true,
      label: 'Quarter Is Required Error',
    }),
    cantFindStreetOrQuarterMessage: FieldTypeFactory.text({
      required: true,
      label: "Can't Find Street Or Quarter Label",
    }),
    cityIsRequired: FieldTypeFactory.text({
      required: true,
      label: 'City Is Required Error',
    }),
    officeIsRequired: FieldTypeFactory.text({
      required: true,
      label: 'Office Is Required Error',
    }),
    selectCourier: FieldTypeFactory.text({
      required: true,
      label: 'Select Courier Error',
    }),
    invalidPhoneNumber: FieldTypeFactory.text({
      required: true,
      label: 'Invalid Phone Number Error',
    }),
  },
  footerButtons: FieldTypeFactory.list({
    of: {
      url: FieldTypeFactory.text(),
      label: FieldTypeFactory.text(),
      icon: FieldTypeFactory.text(),
    },
  }),
  labels: {
    deliveryStepTitle: FieldTypeFactory.text({
      required: true,
      label: 'Delivery Step Title',
      defaultValue: 'Данни за доставката',
    }),
    invoiceStepTitle: FieldTypeFactory.text({
      required: true,
      label: 'Invoice Step Title',
      defaultValue: 'Данни за фактуриране',
    }),
    hippoCard: {
      title: FieldTypeFactory.text({
        required: true,
        label: 'Hippo card',
        defaultValue: 'Хипо карта',
      }),
      placeholder: FieldTypeFactory.text({
        required: true,
        label: 'Card number',
        defaultValue: 'Номер на карта...',
      }),
    },
    paymentStepTitle: FieldTypeFactory.text({
      required: true,
      label: 'Payment Step Title',
      defaultValue: 'Начин на плащане',
    }),
    summaryTitle: FieldTypeFactory.text({
      required: true,
      label: 'Order Summary Title',
      defaultValue: 'Данни за поръчката',
    }),
    totalWithoutShippingPrice: FieldTypeFactory.text({
      required: true,
      label: 'Total Price Without Delivery Label',
      defaultValue: 'Всички продукти',
    }),
    totalShippingPrice: FieldTypeFactory.text({
      required: true,
      label: 'Total Delivery Price Label',
      defaultValue: 'Доставка',
    }),
    totalPrice: FieldTypeFactory.text({
      required: true,
      label: 'Total Price Label',
      defaultValue: 'Общо',
    }),
    shippingPriceNotAvailable: FieldTypeFactory.text({
      required: true,
      label: 'Shipping Price Not Available Label',
      defaultValue: 'N/A',
    }),

    personalInfo: FieldTypeFactory.text({
      required: true,
      label: 'Personal Info Text',
      defaultValue: 'Лични Данни',
    }),
    namesLabel: FieldTypeFactory.text({
      required: true,
      label: 'Names Input Label',
      defaultValue: 'Име',
    }),
    phoneLabel: FieldTypeFactory.text({
      required: true,
      label: 'Phone Input Label',
      defaultValue: 'Телефон',
    }),
    emailLabel: FieldTypeFactory.text({
      required: true,
      label: 'Email Input Label',
      defaultValue: 'Имейл',
    }),
    invalidEmail: FieldTypeFactory.text({
      required: true,
      label: 'Invalid Email Error',
      defaultValue: 'Невалиден имейл',
    }),
    chooseCourier: FieldTypeFactory.text({
      required: true,
      label: 'Choose Courier Label',
      defaultValue: 'Избор на куриер',
    }),
    deliveryType: FieldTypeFactory.text({
      required: true,
      label: 'Delivery Type Label',
      defaultValue: 'Начин на доставка',
    }),
    saveAsDefaultAddress: FieldTypeFactory.text({
      required: true,
      label: 'Save As Default Address Label',
      defaultValue: 'Запази като основен адрес',
    }),
    deliverToAddress: FieldTypeFactory.text({
      required: true,
      label: 'Deliver To Address Label',
      defaultValue: 'Доставка до адрес',
    }),
    deliverToOffice: FieldTypeFactory.text({
      required: true,
      label: 'Deliver To Office Label',
      defaultValue: 'Офис на куриер',
    }),

    companyDetails: FieldTypeFactory.text({
      required: true,
      label: 'Company Details Label',
      defaultValue: 'Данни за фирмата',
    }),
    companyNameLabel: FieldTypeFactory.text({
      required: true,
      label: 'Company Name Label',
      defaultValue: 'Име на фирмата',
    }),
    vatNumberLabel: FieldTypeFactory.text({
      required: true,
      label: 'VAT number (ДДС номер) Label',
      defaultValue: 'ДДС номер',
    }),
    uicLabel: FieldTypeFactory.text({
      required: true,
      label: 'UIC (ЕИК) Label',
      defaultValue: 'ЕИК',
    }),
    molLabel: FieldTypeFactory.text({
      required: true,
      label: 'MOL Label',
      defaultValue: 'МОЛ',
    }),
    companyAddressLabel: FieldTypeFactory.text({
      required: true,
      label: 'Company Address Label',
      defaultValue: 'Адрес',
    }),
    saveAsDefaultCompany: FieldTypeFactory.text({
      required: true,
      label: 'Save As Default Company Label',
      defaultValue: 'Запази като основна фирма',
    }),
    withInvoiceLabel: FieldTypeFactory.text({
      required: true,
      label: 'With Invoice Checkbox Label',
      defaultValue: 'Желая фактура',
    }),

    addNewCompanyLabel: FieldTypeFactory.text({
      required: true,
      label: 'Add New Company Label',
      defaultValue: 'Добави нова фирма',
    }),
    addNewAddress: FieldTypeFactory.text({
      required: true,
      label: 'Add New Address Label',
      defaultValue: 'Добави нов адрес',
    }),
    cityLabel: FieldTypeFactory.text({
      required: true,
      label: 'City Label',
      defaultValue: 'Град',
    }),
    quarterLabel: FieldTypeFactory.text({
      required: true,
      label: 'Quarter Label',
      defaultValue: 'Квартал',
    }),
    streetLabel: FieldTypeFactory.text({
      required: true,
      label: 'Street Label',
      defaultValue: 'Улица',
    }),
    streetNumberLabel: FieldTypeFactory.text({
      required: true,
      label: 'Street Number Label',
      defaultValue: 'Номер',
    }),
    postalCodeLabel: FieldTypeFactory.text({
      required: true,
      label: 'Postal Code Label',
      defaultValue: 'Пощ. код',
    }),
    buildingLabel: FieldTypeFactory.text({
      required: true,
      label: 'Building Label',
      defaultValue: 'Блок',
    }),
    entranceLabel: FieldTypeFactory.text({
      required: true,
      label: 'Entrance Label',
      defaultValue: 'Вход',
    }),
    floorLabel: FieldTypeFactory.text({
      required: true,
      label: 'Floor Label',
      defaultValue: 'Етаж',
    }),
    apartmentLabel: FieldTypeFactory.text({
      required: true,
      label: 'Apartment Label',
      defaultValue: 'Апартамент',
    }),
    additionalAddressInfoLabel: FieldTypeFactory.text({
      required: true,
      label: 'Additional Address Info Label',
      defaultValue: 'Допълнителна информация',
    }),
    officeLabel: FieldTypeFactory.text({
      required: true,
      label: 'Courier Office Label',
      defaultValue: 'Офис',
    }),

    editLabel: FieldTypeFactory.text({
      required: true,
      label: 'Edit Label',
      defaultValue: 'Редактирай',
    }),
    primaryCompanyLabel: FieldTypeFactory.text({
      required: true,
      label: 'Primary Company Label',
      defaultValue: 'Основна фирма',
    }),

    codLabel: FieldTypeFactory.text({
      required: true,
      label: 'Cash On Delivery Payment Type Label',
      defaultValue: 'Наложен Платеж',
    }),
    boricaLabel: FieldTypeFactory.text({
      required: true,
      label: 'Borica Payment Type Label',
      defaultValue: 'Кредитна/Дебитна карта',
    }),

    submitButtonLabel: FieldTypeFactory.text({
      required: true,
      label: 'Submit Order Button Label',
      defaultValue: 'Завърши поръчката',
    }),

    securityNotice: FieldTypeFactory.text({
      required: true,
      label: 'Security notice',
      defaultValue: 'Вашата платежна информация е сигурна',
    }),

    previewItemsLabel: FieldTypeFactory.text({
      required: true,
      label: 'Submit Order Button Label',
      defaultValue: 'Завърши поръчката',
    }),

    outOfStockMessage: FieldTypeFactory.text({
      required: true,
      defaultValue:
        'Някой продукти са извън наличност или вече не се предлагат',
    }),
    pickACourier: FieldTypeFactory.text({
      required: true,
      defaultValue: 'Изберете куриер',
    }),
    saveTheCompanyData: FieldTypeFactory.text({
      required: true,
      defaultValue: 'Запази фирмата',
    }),
    saveAddress: FieldTypeFactory.text({
      required: true,
      defaultValue: 'Запази адреса',
    }),
    validations: {
      saveOrAddNewCompany: FieldTypeFactory.text({
        required: true,
        defaultValue: 'Изберете фирма или добавете нова',
      }),
      saveOrAddNewAddress: FieldTypeFactory.text({
        required: true,
        defaultValue: 'Изберете адрес или добавете нов',
      }),
    },
  },
})
